import { Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { Home } from "./pages/Home";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { Preco } from "./pages/Preco";
import { Checkout } from "./pages/Checkout";
import { Termos } from "./pages/Termos";
import { Privacidade } from "./pages/Privacidade";
import { Sobre } from "./pages/Sobre";
import { Blog } from "./pages/Blog";
import { BlogPost } from "./pages/BlogPost";
import { DynamicFeaturePage } from "./pages/DynamicFeaturePage";
import { CasosSucesso } from "./pages/CasosSucesso";
import { Parceiros } from "./pages/Parceiros";
import { Contato } from "./pages/Contato";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/preco" element={<Preco />} />
        <Route path="/termos" element={<Termos />} />
        <Route path="/privacidade" element={<Privacidade />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/clientes" element={<CasosSucesso />} />
        <Route path="/parceiros" element={<Parceiros />} />
        <Route path="/contato" element={<Contato />} />
        
        {/* Rotas Dinâmicas do Submenu Principal */}
        <Route path="/industrias/:id" element={<DynamicFeaturePage />} />
        <Route path="/solucoes/:id" element={<DynamicFeaturePage />} />
        <Route path="/recursos/:id" element={<DynamicFeaturePage />} />
        
        {/* Produtos Footer */}
        <Route path="/erp" element={<DynamicFeaturePage />} />
        <Route path="/crm" element={<DynamicFeaturePage />} />
        <Route path="/agendamento" element={<DynamicFeaturePage />} />
        <Route path="/fiscal" element={<DynamicFeaturePage />} />
        
        {/* Módulos (Operacional/Financeiro) */}
        <Route path="/catalogo-vendas" element={<DynamicFeaturePage />} />
        <Route path="/pdv" element={<DynamicFeaturePage />} />
        <Route path="/ordem-servico" element={<DynamicFeaturePage />} />
        <Route path="/estoque" element={<DynamicFeaturePage />} />
        <Route path="/venda-cruzada" element={<DynamicFeaturePage />} />
        <Route path="/contas-pagar" element={<DynamicFeaturePage />} />
        <Route path="/contas-receber" element={<DynamicFeaturePage />} />
        <Route path="/controle-caixa" element={<DynamicFeaturePage />} />
        <Route path="/relatorios" element={<DynamicFeaturePage />} />
        <Route path="/modulos" element={<DynamicFeaturePage />} />
        {/* Checkout SaaS canônico (nginx DEV: location = /checkout → :3001) */}
        <Route path="/checkout" element={<Checkout />} />

      </Route>
      {/* Rotas sem o Header/Footer padrão */}
      <Route path="/login" element={<Login />} />
      <Route path="/cadastro" element={<Register />} />
      <Route path="/cadastro-empresa" element={<Navigate to="/cadastro" replace />} />
    </Routes>
  );
}
